import React, { FC, useLayoutEffect, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { Routes, Route, useParams } from 'react-router-dom';

import VehicleSearch from '../vehicle-search';
import Breadcrumbs from '../breadcrumbs';
import Detail from '../detail';
import List from '../list';
import overall from '../../store/overall';
import storeCurrentVehicle from '../../../d-search-bar/store/current-vehicle';

const Wrapper: FC = () => {
  const { vType } = useParams();

  const setLinkToFMP = (): any => {
    const link : HTMLLinkElement = document.querySelector("[data-attr='fmp-link']");
    if (storeCurrentVehicle.current) {
      link.href = `/catalog/${storeCurrentVehicle.current.vehicleType}/${storeCurrentVehicle.current.id}`;
    } else {
      link.href = '/catalog';
    }
  };

  useLayoutEffect(() => {
    if (!overall.prefix) {
      overall.setPrefix(vType);
    }
  }, []);

  useCallback(setLinkToFMP(), [storeCurrentVehicle.current]);

  return (
    <div className="page-fmp__app">
      <VehicleSearch />
      <Breadcrumbs />

      <Routes>
        <Route path=":carId/part/:partName" element={<Detail />} />
        <Route path="part/:partName" element={<Detail />} />
        <Route path=":carId/:catLevel1?/:catLevel2?/:catLevel3?" element={<List />} />
        <Route path=":catLevel1?/:catLevel2?/:catLevel3?" element={<List />} />
      </Routes>
    </div>
  );
};

export default observer(Wrapper);
